const LOCAL_SITE_PREVIEW_URL = 'http://localhost:3000'
const PUBLIC_SITE_PREVIEW_URL = 'https://newdriver.com.br'

function getPortalPreviewBaseUrl() {
  const hostname = window.location.hostname

  if (hostname === 'localhost') {
    return LOCAL_SITE_PREVIEW_URL
  }

  return PUBLIC_SITE_PREVIEW_URL
}

export function getPortalPreviewUrl() {
  const baseUrl = getPortalPreviewBaseUrl().replace(/\/+$/, '')

  return `${baseUrl}/portal-preview`
}

export function getPortalPreviewTargetOrigin() {
  return new URL(getPortalPreviewUrl()).origin
}
